import router from 'next/router';
import {TrackPageViewContainer} from '../../../../common/containers/TrackPageViewContainer';
import {requestContext} from '../../../../common/requestContext';
import {TRIGGER_COMMAND_KEY} from '../../../../common/shared/constants';
import {
  COMMAND_KEY,
  useCommandWithLocalStorage,
} from '../../../../common/shared/hooks/useCommandWithLocalStorage';
import {GetRefundableAmountQuery} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {SelfCertRequestType} from '../../../../selfCert/SelfCertRequestType.enum';
import {processSelfCertRequest} from '../../../../user/processSelfCertRequest';
import {createRefundableAmountTableRows} from '../../../common/util/createRefundableAmountTableRows';
import {isUnderAge14} from '../../../common/util/isUnderAge14';
import {showAgeUnder14Dialog} from '../../../common/util/showAgeUnder14Dialog';
import {CreditRefundAgreement} from '../presentational/CreditRefundAgreement';

export function CreditRefundAgreementContainer({
  refundableAmountData,
}: {
  refundableAmountData?: GetRefundableAmountQuery;
}) {
  const {saveCommand} = useCommandWithLocalStorage();
  const finalRefundableAmount =
    refundableAmountData?.refundableAmount?.finalRefundableAmount || 0;
  return (
    <>
      <CreditRefundAgreement
        refundableAmount={finalRefundableAmount}
        refundCreditInfoRowList={createRefundableAmountTableRows(
          refundableAmountData?.refundableAmount
        )}
        onClickNext={e =>
          LOG_CLICK_EVENT('다음_클릭', e, async () => {
            if (isUnderAge14(requestContext.requestInfo.user?.age)) {
              showAgeUnder14Dialog({
                isMobile: requestContext.requestInfo.display.isMobile,
              });
              return;
            }

            const nextPathname = '/credit-refund/request';
            await saveCommand({
              commandKey: COMMAND_KEY.VERIFY_FINAL_REFUNDABLE_AMOUNT,
              command: {
                location: nextPathname,
                amount: finalRefundableAmount,
              },
            });
            if (!requestContext.requestInfo.user?.age) {
              processSelfCertRequest({
                selfCertRequestParams: {
                  type: SelfCertRequestType.CreditRefund,
                  success_url: `${window.location.origin}${nextPathname}?${TRIGGER_COMMAND_KEY}=${COMMAND_KEY.VERIFY_FINAL_REFUNDABLE_AMOUNT}`,
                  redirect_in_window: false,
                },
              });
            } else {
              router.push(
                `${nextPathname}?${TRIGGER_COMMAND_KEY}=${COMMAND_KEY.VERIFY_FINAL_REFUNDABLE_AMOUNT}`
              );
            }
          })
        }
        isMobile={requestContext.requestInfo.display.isMobile}
      />
      <TrackPageViewContainer
        trackObj={{
          section: '더보기',
          page: `고객센터_캐시환불접수_${
            finalRefundableAmount ? '동의문' : '0원'
          }`,
          actionType: 'Pageview',
          actionName: `캐시환불접수_${
            finalRefundableAmount ? '동의문' : '0원'
          }_화면`,
          customProps: {
            user_action: 'pv',
          },
        }}
      />
    </>
  );
}
